import type { Node_Type, RichContent, TextStyle_TextAlignment } from 'ricos-schema';

export const EmptyRichContentState: RichContent = {
  nodes: [
    {
      type: 'PARAGRAPH' as Node_Type,
      id: 'm1np0803',
      nodes: [],
      paragraphData: {
        textStyle: {
          textAlignment: 'AUTO' as TextStyle_TextAlignment,
        },
        indentation: 0,
      },
    },
  ],
  metadata: {
    version: 1,
    id: '0a67745a-71da-4153-afcc-576aeca2ab17',
  },
  documentStyle: {},
};
